import { JUNIOR_ENVIRONMENTS, JUNIOR_SPEECH_API_URL } from '@/shared/config/junior';
import { decodeGameConfig } from '@/shared/utils/gameConfig';

const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
const hasJuniorApi = queryParams.get('api') === 'junior';
const isJunior = hasJuniorApi && queryParams.has('config');
const queryConfig = isJunior ? decodeGameConfig(queryParams.get('config')) : undefined;

const environment = import.meta.env.VITE_ENVIRONMENT || '';
const defaultJuniorEnvironment =
	environment === 'production' ? 'nl_master' : environment === 'staging' ? 'nl_staging' : 'nl_develop';
const juniorEnvironment = JUNIOR_ENVIRONMENTS[queryConfig?.env ?? defaultJuniorEnvironment];

const config = {
	is_development: import.meta.env.DEV,
	debug: queryParams.get('debug') === 'true',
	is_junior: isJunior,
	junior_api_url: juniorEnvironment.api_url,
	junior_speech_api_url: JUNIOR_SPEECH_API_URL,
	junior_oauth_client_id: juniorEnvironment.oauth_client_id,
	junior_oauth_response_type: juniorEnvironment.oauth_response_type,
	junior_oauth_auth_url: juniorEnvironment.oauth_auth_url,
	game_config_error: queryConfig?.error,
	api_url: import.meta.env.VITE_SQULA_API_URL || '',
	enable_speak_audio: import.meta.env.VITE_ENABLE_SPEAK_AUDIO !== 'false',
	use_dummy_game_data: !isJunior,
	resources_url: import.meta.env.VITE_RESOURCES_URL || '',
	frontend_url: import.meta.env.VITE_FRONTEND_URL || '',
	data_href: queryConfig?.data_href,
	exit_url: hasJuniorApi ? queryConfig?.exit_url || 'uniwebview://web-edx/exit' : '',
	oauth_client_id: import.meta.env.VITE_OAUTH_CLIENT_ID || 'learning_path@squla',
	oauth_client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET || '',
	oauth_username: import.meta.env.VITE_OAUTH_USERNAME || '',
	oauth_password: import.meta.env.VITE_OAUTH_PASSWORD || '',
	authentication_cookies_domain: import.meta.env.VITE_AUTHENTICATION_COOKIES_DOMAIN || '',
	authentication_cookies_suffix: import.meta.env.VITE_AUTHENTICATION_COOKIES_SUFFIX || '',
	environment,
	brand_name: import.meta.env.VITE_BRAND_NAME || '',
	bugsnag_api_key: import.meta.env.VITE_BUGSNAG_API_KEY || '',
	react_app_build_number: import.meta.env.VITE_BUILD_NUMBER || '',
	build_url: import.meta.env.VITE_BUILD_URL || '.',
};

export default config;
